const ns = {};

/**
 * Fadet Nachrichten nach kurzer Zeit aus.
 *
 * @param {String} selector jQuery-Selector fuer die auszufadenden Nachrichten.
 * @returns {MessageFader}
 */
ns.MessageFader = function(selector) {
    this.selector = selector;
};

/**
 * Durchsucht das uebergebene Element nach Nachrichten und fadet diese
 * nacheinander aus.
 *
 * @param {jQuery} el Das zu bearbeitende Element
 */
ns.MessageFader.prototype.process = function(el) {

    var messages       = el.find(this.selector).reverse();
    var delayOfCurrent = 0;

    messages.each(function(idx, el) {

        setTimeout(function() {
            $(el).fadeOut();
        }, 1600 + delayOfCurrent);

        delayOfCurrent += 700;
    });
};

export default ns.MessageFader;
